import React from 'react';
import { label } from '../../../../../helpers/forms/label';
import { FormCreateLyceeTypes } from './FormCreateLycee';
import { Academie } from '../../../../../types/academie/academie.def';
import { LabelInput } from '../../../../atoms/Inputs/LabelInput';
import { Select } from '../../../../atoms/Inputs/Select';
import useStyle from './createLycee.style';

interface FormCreateLyceeViewProps extends FormCreateLyceeTypes {
  academies: Array<Academie>;
}

const FormCreateLyceeView = ({
  lycee,
  handleChange,
  academies
}: FormCreateLyceeViewProps) => {
  const classes = useStyle();
  const handleChangeAcad = value => {
    const e = {
      target: {
        value: value,
        name: 'academie'
      }
    };
    handleChange(e);
  };
  return (
    <div className={classes.root}>
      <LabelInput
        label={label('lyceeName')}
        name={'name'}
        placeHolder={'Ex: Joseph Saverne'}
        onChange={handleChange}
        value={lycee.values.name || ''}
        error={lycee.errors.name}
        required={true}
      />
      <LabelInput
        label="Ville"
        name="ville"
        placeHolder="Ex: Albi"
        onChange={handleChange}
        value={lycee.values.ville || ''}
        error={lycee.errors.ville}
      />
      <LabelInput
        label="Adresse"
        name="adresse"
        placeHolder="Ex: 24 rue Jean Le Rond D'Alembert"
        onChange={handleChange}
        value={lycee.values.adresse || ''}
        error={lycee.errors.adresse}
      />
      <LabelInput
        label="Code Postal"
        name="codepostal"
        placeHolder="Ex: 81000"
        onChange={handleChange}
        value={lycee.values.codepostal || ''}
        error={lycee.errors.codepostal}
        required={true}
      />
      <LabelInput
        label={'Téléphone'}
        name="tel"
        placeHolder="Ex: 0506070809"
        onChange={handleChange}
        value={lycee.values.tel || ''}
        error={lycee.errors.tel}
        required={true}
      />
      {academies && (
        <div className={classes.academieSelectContainer}>
          <p className={classes.academieLabel}>Académie</p>
          <Select
            onChange={handleChangeAcad}
            value={lycee.values.academie}
            variant="form"
            productsOptions={academies}
            initialOptionName={'Choisir une academie'}
            disabledInitialOption
          />
        </div>
      )}
    </div>
  );
};

export default FormCreateLyceeView;
